import { Card, CardContent } from '@/components/ui/card';
import type { ActivityOverviewStatusCounts } from '@sparkapp/shared-types';

interface StatusStatCardsProps {
  counts?: ActivityOverviewStatusCounts;
  isLoading: boolean;
}

const CARDS: Array<{ key: keyof ActivityOverviewStatusCounts; label: string }> = [
  { key: 'total', label: 'Total activities' },
  { key: 'published', label: 'Published' },
  { key: 'draft', label: 'Draft' },
  { key: 'unpublished', label: 'Unpublished' },
  { key: 'archived', label: 'Archived' },
];

/**
 * Header stat cards — always unfiltered, unaffected by the status filter.
 */
export function StatusStatCards({ counts, isLoading }: StatusStatCardsProps) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
      {CARDS.map((card) => (
        <Card
          key={card.key}
          className="bg-pine-card border-pine-line shadow-pine-card rounded-pine-card"
        >
          <CardContent className="pt-6">
            <p className="text-caption text-pine-ink-soft mb-1">{card.label}</p>
            {isLoading || !counts ? (
              <div className="h-8 w-16 bg-pine-line animate-pulse rounded" />
            ) : (
              <p className="text-heading-3 text-pine-ink font-semibold">
                {counts[card.key]}
              </p>
            )}
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
